import { ScrollTop } from "@/components/commons/ScrollTop";
import { RuntimeEnvTagCorner } from "@/components/elements/RuntimeEnvTag";
import { withGuest } from "@/hoc/withGuest";
import { logout } from "@/utils/logout";
import { Box } from "@mui/material";
import { FC, useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";

export const LoginLayout: FC = () => {
  // If a token is present, force a logout by clearing auth-related web storage only.
  useLayoutEffect(logout, []);

  return (
    <Box
      width="100%"
      minHeight="100vh"
      display="flex"
      justifyContent="center"
      pt={13}
      pb={4}
      bgcolor="#F8F9F9"
      position="relative"
      sx={{ overflowY: "auto" }}
    >
      <ScrollTop />
      <RuntimeEnvTagCorner />
      <Outlet />
    </Box>
  );
};

export const LoginLayoutWithGuest = withGuest(LoginLayout);
